import { ActivatedRoute } from '@angular/router';
import {
  Component,
  Input,
  OnInit,
  Output,
  EventEmitter,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Subscription } from 'rxjs';

import { IProductCommission } from './../../../models/commission';
import { ApiCommissionService } from 'src/app/services/api/api-commission.service';
import { ApiDialogService } from 'src/app/services/api/api-cdialog.service';
import { TransferTabs } from './../../../models/tabs';
import { TabTypeEnum } from 'src/app/models/generic';
import { ITab } from 'src/app/models/tabs';
import { DialogTypeEnum, IDialogConfirm } from 'src/app/models/dialog';

@Component({
  selector: 'app-tabs-navigation',
  templateUrl: './tabs-navigation.component.html',
  styleUrls: ['./tabs-navigation.component.scss']
})
export class TabsNavigationComponent implements OnInit, OnDestroy, OnChanges {
  TabTypeEnum = TabTypeEnum;

  TransferTabs = TransferTabs;

  @Input() currentTab!: number | string;
  @Input() tabs!: ITab[];
  @Input() mode = 'visualizar';
  @Input() type!: number;
  @Input() position = 'center';
  @Input() products: IProductCommission[] = [];
  @Input() appearance: 'legacy' | 'modern' = 'legacy';

  @Output() changeTabsEvent = new EventEmitter<number | string>();
  @Output() insertProductEvent = new EventEmitter<IProductCommission>();
  @Output() deleteProductByTabEvent = new EventEmitter<string>();

  firstElement: number = 0;

  changeTabsSubscription!: Subscription;

  constructor(
    private _commissionService: ApiCommissionService,
    private _dialogService: ApiDialogService,
    private _route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    this.listeningEvents();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (
      (changes['tabs'] || changes['type']) &&
      this.type !== TabTypeEnum.Link &&
      this.type
    ) {
      const hasCurrentTab = this.tabs?.some((tab) => tab.id === this.currentTab);

      if (!this.currentTab || !hasCurrentTab) {
        this.currentTab = this.tabs[this.firstElement]?.id as string | number;
      }
    }
  }

  ngOnDestroy(): void {
    if (this.changeTabsSubscription) this.changeTabsSubscription.unsubscribe();
  }

  listeningEvents(): void {
    this.changeTabsSubscription =
      this._commissionService.changeProductTabs.subscribe({
        next: (response) => {
          this.currentTab = response;
        }
      });
  }

  changeTab(tab: number | string = this.TransferTabs.NotaFiscal): void {
    if (
      (this.type === this.TabTypeEnum.Modal ||
        this.type === this.TabTypeEnum.Render) &&
      this.currentTab !== tab
    ) {
      this.currentTab = tab;
      this.changeTabsEvent.emit(this.currentTab);
    } else {
      this.currentTab = tab;
    }
  }

  insertProduct(product: IProductCommission): void {
    this.insertProductEvent.emit(product);
  }

  deleteTab(tab: ITab): void {
    const dialogData: IDialogConfirm = {
      type: DialogTypeEnum.Optional,
      appearance: 'modern',
      template: {
        boldTitle: 'Remover produto',
        title: `Deseja remover o produto ${tab.title}?`,
        confirm: 'Sim',
        dismiss: 'Não'
      }
    };

    this._dialogService.openDialog(dialogData).then((response) => {
      if (response) {
        this.deleteProductByTabEvent.emit(tab.id as string);
        this.currentTab = this.tabs[this.firstElement].id as string;
      }
    });
  }
}
